module.exports = __webpack_public_path__ + "media/img/slider1-3d0f000469efa8f5863d14dff2bf7e3f.png";